import React from "react";

interface MobileSelectionBarProps {
  selectedCount: number;
  totalCount: number;
  onToggleAll: () => void;
  onCancel: () => void;
  actionLabel: string;
  onAction: () => void;
  actionDisabled?: boolean;
}

/** Bottom bar for list multi-select modes ("N selected" + bulk action). */
const MobileSelectionBar: React.FC<MobileSelectionBarProps> = ({
  selectedCount,
  totalCount,
  onToggleAll,
  onCancel,
  actionLabel,
  onAction,
  actionDisabled,
}) => {
  const allSelected = totalCount > 0 && selectedCount === totalCount;

  return (
    <div className="border-t border-gray-100 bg-white/95 px-4 pt-3 pb-3 shadow-[0_-4px_16px_rgba(13,14,19,0.06)] backdrop-blur-md">
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm font-semibold text-gray-900">
            {selectedCount} selected
          </p>
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={onToggleAll}
              disabled={totalCount === 0}
              className="border-0 bg-transparent p-0 text-[13px] font-medium text-primary-600 active:opacity-60 disabled:opacity-40"
            >
              {allSelected ? "Clear all" : "Select all"}
            </button>
            <button
              type="button"
              onClick={onCancel}
              className="border-0 bg-transparent p-0 text-[13px] font-medium text-gray-500 active:opacity-60"
            >
              Cancel
            </button>
          </div>
        </div>
        <button
          type="button"
          onClick={onAction}
          disabled={actionDisabled}
          className="h-11 shrink-0 rounded-2xl border-0 bg-primary-600 px-5 text-sm font-semibold text-white active:bg-primary-700 disabled:opacity-40"
        >
          {actionLabel}
        </button>
      </div>
    </div>
  );
};

export default MobileSelectionBar;
